import styled from 'styled-components';
export var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1wsry8d-0"
})(["svg{width:54px;height:54px;}"]);